import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { modalSelector, hideModal } from "../../store/modalSlice";
import { Button } from "../Button";
import "./index.scss";

/**
 * @desc Global modal. Controlled by modal slice (store).
 */
export const Modal = ({
  id,
  children,
  header,
  ctaText,
  onClick,
  showCancelButton,
  image,
  disabled,
}) => {
  // CONSTANTS ----------------------------------------------------------------

  const dispatch = useDispatch();
  const { show, id: displayModalID } = useSelector(modalSelector);

  // HANDLERS -----------------------------------------------------------------

  /**
   * @desc Close the modal.
   */
  const onClose = (e) => {
    if (e.currentTarget && e.currentTarget !== e.target) return;
    dispatch(hideModal());
  };

  // METHODS ------------------------------------------------------------------

  /**
   * @desc Render header, if possible.
   */
  const renderHeader = () => {
    if (!header) return;
    return <div className="modal-header">{header}</div>;
  };

  /**
   * @desc Render close button, if possible.
   */
  const renderCloseButton = () => {
    if (!showCancelButton) return;
    const props = {
      className: "close-btn secondary",
      children: "CANCEL",
      onClick: onClose,
    };
    return <Button {...props} />;
  };

  /**
   * @desc Render modal content.
   */
  const renderModalContent = () => {
    const buttonProps = {
      onClick: onClose,
      type: "button",
      className: "close",
      "data-dismiss": "modal",
      "aria-label": "Close",
    };

    const closeImgProps = {
      onClick: onClose,
      className: "svg-symbol modal-close-x",
      src: "https://funko.com/on/demandware.static/Sites-FunkoUS-Site/-/default/dw18700a64/images/funko/svg/modal-close-x.svg",
      alt: "close button",
      role: "presentation",
    };

    const ctaProps = {
      disabled,
      className: "modal-cta",
      onClick: async (e) => {
        if (typeof onClick === typeof Function) {
          await onClick(e);
        }
        onClose(e);
      },
    };

    return (
      <div className="modal-content">
        {renderHeader()}
        <button {...buttonProps}>
          <img alt={"close-button"} {...closeImgProps} />
        </button>
        <div className="modal-children">{children}</div>
        <div className="modal-buttons">
          {renderCloseButton()}
          <Button {...ctaProps}>{ctaText || "Okay"}</Button>
        </div>
      </div>
    );
  };

  // COMPONENT ----------------------------------------------------------------

  const visible = show && displayModalID === id;
  const props = {
    onClick: onClose,
    className: `modal fade centered-modal-style ${visible ? "show" : "hide"}`,
    tabIndex: "-1",
    "aria-modal": true,
    role: "dialog",
    "aria-labelledby": "modal-label",
  };

  return (
    <div {...props}>
      <div
        className={`modal-dialog ${
          image ? "modal-xl" : "modal-sm"
        } modal-dialog-centered`}
      >
        {renderModalContent()}
      </div>
    </div>
  );
};
